import React, { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";

const WarningMessage = ({
    message = "Group with more than 10,000 numbers are not allowed.",
    blinkSpeed = 1.5, // seconds
}) => {
    return (
        <Box
            sx={{
                padding: 2,
                marginBottom: 2,
                textAlign: "center",

                border: "1px solid red",
                borderRadius: 1,
                animation: `shine ${blinkSpeed}s infinite alternate`,
                "@keyframes shine": {
                    "0%": {
                        boxShadow: "0 0 5px rgba(255, 0, 0, 0.2)",
                    },
                    "100%": {
                        boxShadow: "0 0 20px rgba(255, 0, 0, 0.4)",
                    },
                },
            }}
        >
            <Typography
                sx={{
                    color: "red",
                    fontWeight: 800,
                    textShadow: "0 0 2px rgba(255, 0, 0, 0.3)",
                }}
            >
                {message}
            </Typography>
        </Box>
    );
};

export default WarningMessage;
